const t = {
    icon: 'fa-user-tie',
    menus: {
        main: {section: 'customers', priority: 10},
    },
    new: {
        attributes: [
            'customer', 'employee', 'tenant','project','rate','dateStart','dateEnd'
        ],
        content: [
            ['row', [
                ['block', [
                    '$tenant!', '$customer!', '$employee!','$project!','$rate!','$dateStart!','$dateEnd!'
                ]],
            ]],
            '$submit',
        ],
    },
    edit: {
        attributes: [
            'customer','endCustomerName', 'employee', 'tenant','project','rate'
        ],
        content: [
            ['row', [
                ['block', [
                    '$tenant:readonly!', '$code:readonly!','$project:readonly!','$endCustomerName', '$employee!', '$customer!','$rate!'
                ]],
            ]],
            '$submit',
        ],
    },
    display: {
        toolbar: true,
        properties: [
            'id', ['code'], 'customer','project', 'employee', 'tenant', ['rate' ]
        ],
    },
    list: {
        props: {
            search: false,
            searchSwitch: false,
        },
        icon: 'fa-handshake-simple',
        columns: [
            {id: 'code', label:'column_code_label'},
            {id: 'status', label: 'column_status_label'},
            {id: 'customerName', label: 'column_customer_label'},
            {id: 'employeeFirstName', label: 'column_employee_label'},
            {id: 'project', label: 'column_project_label'},
            {id: 'tenantName', label: 'column_tenant_label'},
            {id: 'rate', label: 'column_rate_label', format: (v: any) => v ? v/100: undefined},
            {id: 'externalId', label: 'column_externalid_label'},
            {id: 'dateStart', label: 'column_datestart_label', format:  (v: any) => v ? new Date(parseInt(v)*1000).toLocaleString() : 'undefined'},
            {id: 'dateEnd', label: 'column_dateend_label', format: (v: any) => v ? new Date(parseInt(v)*1000).toLocaleString() : 'undefined'},
        ],
        globalActions: ['add'],
        actions: ['display', 'edit', 'delete'],
    },
};

export default t;